import { useMemo } from 'react'
import { NavLink } from 'react-router'
import { useIntl } from 'react-intl'

import './Breadcrumb.css'

export interface Crumb {
  label: React.ReactNode
  path: string
}

interface BreadcrumbProps {
  crumbs?: Crumb[]
}

export default function Breadcrumb({ crumbs = [] }: BreadcrumbProps) {
  const intl = useIntl()
  const allCrumbs = useMemo(
    () => [
      { label: intl.formatMessage({ id: 'nav.home' }), path: '/' },
      ...crumbs
    ],
    [crumbs, intl]
  )

  return (
    <nav className="breadcrumb">
      <ul>
        {allCrumbs.map((crumb, index) => (
          <li key={crumb.path}>
            <NavLink
              to={crumb.path}
              className={({ isActive }) =>
                `breadcrumb-link${isActive ? ' active' : ''}`
              }
            >
              <span title={crumb.label + ''} className="ellipsis">
                {crumb.label}
              </span>
              {index < allCrumbs.length - 1 && (
                <span className="icon icon-angle-right" />
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
